import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/app/not-found.tsx");
